<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        height: '70%',
        color: '#fff',
    }" class="addressPopup">
        <div class="addressBook_container">
            <div class="popTitle">{{ $t('withdraw.selectAddress') }}</div>
            <div class="mainTab">
                <van-tabs v-model="active" :ellipsis="false" @click-tab="onClickTab">
                    <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="item.id">
                    </van-tab>
                </van-tabs>
            </div>
            <div class="subTab">
                <van-tabs v-model:active="activeSub" :ellipsis="false" @click-tab="onClickSubTab">
                    <van-tab v-for="(item, index) in subTabList" :key="index" :title="$t(item.name)" :name="item.id">
                        <div class="content">
                            <div v-for="(item, i) in addressList" :key="i">
                                <address-book-card :channe-label="item.address_label" :address="item.address"
                                    :chain-type="item.chain_type" @update-address-book="fetchAddressBook"/>
                            </div>
                            <div class="btn_container">
                                <main-button :title="$t('withdraw.addNewAddress')" :activeStatus="true"
                                    @click="openAddAddressPopup" />
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>

        </div>
        <add-address-popup ref="addAddressRef"  @update-addressbook="fetchAddressBook"
            @call-network-options="(value) => emits('callNetworkOptions', value)" />
    </van-popup>
</template>
<script lang="ts" setup>
import { AddressChannelItem, callAddressBook, NetworkChannelItem, TAB_ADDRESSBOOK, TAB_SUB_ADDRESSBOOK } from '@/view/withdraw/supportScript';
import { ref } from 'vue';
import AddressBookCard from './addressBookCard.vue';
import MainButton from '../../components/common/mainButton.vue';
import AddAddressPopup from './addAddressPopup.vue';

const show = ref(false);
const activeSub = ref(0)
const active = ref(0)
const tabList = ref(TAB_ADDRESSBOOK)
const subTabList = ref(TAB_SUB_ADDRESSBOOK)
const filterType = ref(1)
const networkType = ref(0)
const addressList = ref<AddressChannelItem[]>([])
const addAddressRef = ref()
const emits = defineEmits(['onClickTab', 'onClickSubTab', 'callNetworkOptions'])
const openPopup = () => {
    fetchAddressBook()
    show.value = true;
}

const closePopup = () => {
    show.value = false;
}
const onClickTab = (data: any) => {
    filterType.value = data.name
    fetchAddressBook()
}
const onClickSubTab = (data: any) => {
    networkType.value = data.name
    fetchAddressBook()
}
const openAddAddressPopup = () => {
    addAddressRef.value.openPopup()
}
const fetchAddressBook = async () => {
    const { addresses } = await callAddressBook(filterType.value, networkType.value)
    addressList.value = addresses
}
defineExpose({
    openPopup
})
</script>
<style scoped>
.addressPopup {
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    border: 0.5px solid rgba(255, 255, 255, 0.15) !important;
    background: #312734 !important;
    opacity: 0.8 !important;
    box-shadow: inset 0px 2px 0px 0px #e150a4 !important;
}

::-webkit-scrollbar {
    display: none;
}

.van-overlay {
    backdrop-filter: blur(5px);
}

.addressBook_container {
    padding: 15px 15px 85px
}

.popTitle {
    font-size: 16px;
    display: flex;
    text-align: center;
    justify-content: center;
    padding: 15px;
}

.mainTab>>>.van-tabs__wrap {
    color: #8b6e8b;
    background: #312734;
    backdrop-filter: blur(8px);
    border-bottom: 1.5px solid #e150a4;
    height: 35px;
}

.mainTab>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.mainTab>>>.van-tab {
    color: #8b6e8b;
    font-weight: 700;
    border-radius: 10px 10px 0 0;
    font-size: 13px;
    margin: 0 3px;
    padding: 0 10px;
}

.mainTab>>>.van-tab.van-tab--active {
    color: #fff;
    background-image: linear-gradient(270deg, rgb(225, 80, 164), rgb(230, 111, 200) 81%);
    font-weight: 700;
}

.mainTab>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;
    /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;
    /* Chrome, Safari, Edge */
}

.subTab {
    padding-top: 15px;
}

.subTab>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.subTab>>>.van-tab {
    background: #40294f;
    color: #8b6e8b;
    border-radius: 10px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.subTab>>>.van-tab.van-tab--active {
    background: #ff3d9e;
    color: #fff;
}

.subTab>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.btn_container {
    padding: 10px 10%;
}
</style>